<template>
  <div>
    <CRow>
      <CCol md="12">
        <userList />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import userList from "../../components/admin/usersList";

export default {
  name: "User_List",
  components: {
    userList,
  },
};
</script>
